import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStop, IStopsInitialState, IStopsList } from '@types';

import { initialStops } from './initialState';

export const stopsSlice = createSlice({
    name: 'stops',
    initialState: initialStops(),
    reducers: {
        setStops(state: IStopsInitialState, action: PayloadAction<IStopsList>) {
            state.stopsList = action.payload;
        },

        setStop(state: IStopsInitialState, action: PayloadAction<IStop | null>) {
            state.stop = action.payload;
        },
    },
});
